import { AGE_LIST, AREA_OF_INTERESTS_LIST, BOROUGH_LIST, BUSINESS_LOCATION, BUSINESS_STAGE, BUSINESS_START_PERIOD, CATEGORIES, EDUCATION_LIST, EMPLOYEES_COUNT, ETHNICITY_LIST, GENDER_LIST, HIGH_GROWTH_INDUSTRY_LIST, HOW_DID_YOU_HEAR_ABOUT_US_LIST, IMPORTANT_GOAL, INCOME_RANGE_LIST, INDUSTRIES, INDUSTRIES_NYC, ITEMS_TYPE, MWBE, OCCUPATION_STATUS_LIST, PROFESSIONAL_EXPERIENCE_LIST, RACE_LIST, REVENUE, THREE_GOALS, ADVISOR_CATEGORIES, CURRENT_INDUSTRY_LIST } from "./formListsTranslations";

export const USER_FORM_LISTS = {
  borough: ["Manhattan", "Queens", "Brooklyn", "Bronx", "Staten Island", "I don't live in NYC"],
  gender:  ["Female", "Male", "Non-binary/Third Gender", "Prefer not to disclose"],
  age: ["18-24", "25-34", "35-44", "45-54", "55-64", "65+", "Prefer not to disclose"], // Age Range
  race: ["Asian", "American Indian or Alaska Native", "Black or African American", "Native Hawaiian or Pacific Islander", "Two or More Races", "White or Caucasian", "Prefer not to disclose"],
  ethnicity: ["Hispanic or Latina(o)", "Not Hispanic or Latina(o)", "Prefer not to disclose"],
  education: [
    "High school or equivalent",
    "Some college",
    "Associate's Degree",
    "Bachelor's Degree",
    "Master's Degree",
    "Doctorate",
    "Professional, Technical or occupational certificate",
    "Prefer not to disclose"
  ],
  incomeRange: [
    "$0-$68,039",
    "$68,040-$90,719",
    "$90,720-$124,739",
    "$124,740-$187,109",
    "$187,110+",
    "Prefer not to disclose",
  ],
  occupationStatus: [
    "Student",
    "Working for an organization",
    "Entrepreneur (Business Owner/Self-Employed)",
    "Solopreneur (Freelancer/Consultant)",
    "Unemployed",
    "In transition",
    "Full-time parenting",
    "Retired",
    "Prefer not to disclose",
  ],
  professionalExperience: [
    "Intern",
    "Entry Level",
    "Mid-career",
    "Management",
    "Senior/Experienced Professional",
    "Other (please specify)",
  ],
  highGrowthIndustry: ["Tech", "Green Economy", "Life Sciences"],
  areaInterest: [
    "Job Interview Prep",
    "Changing Industries",
    "Personal Branding",
    "Networking",
    "Moving Into Management",
    "Entrepreneurship",
    "Jobs of the future",
    "Work-Life Balance",
    "Negotiation Skills",
    "Other (please specify)",
  ],
  advisorCategories: [
    "Career Transition",
    "Industry Insight",
    "Leadership Growth",
    "Strategic Networking",
    "Personal Branding",
    "Job Search Skills",
    "Negotiation & Advocacy",
    "Entrepreneurship & Wealth",
    "Workplace Inclusion",
  ],
  categories: Object.keys(CATEGORIES.en),
  currentIndustry: ["Tech", "Life Sciences", "Green Economy"],
  industries_nyc: Object.keys(INDUSTRIES_NYC.en),
  howYouFoundUs: [
    "Email",
    "Instagram",
    "Twitter",
    "LinkedIn",
    "Facebook",
    "Eventbrite",
    "Word of mouth",
    "Women.nyc website",
    "Internet/Other Social Media"
  ],
  business_start_period: [
    "Less than 1 year ago",
    "1-3 years ago",
    "3-5 years ago",
    "5+ years ago",
    "N/A"
  ],
  mwbe: [
    "Yes, through New York City.",
    "Yes, through New York State.",
    "Yes, I have applied for both state and city certification.",
    "No.",
    "I'm not sure what a MWBE Certification is.",
    "Other"
  ],
  employees_count: [
    "1", "2-4", "5+", "N/A"
  ],
  business_stage: [
    "Pre-Startup (no sales yet)", "Startup (offering goods/services for less than 1 year)", "Operating (sales for 1+ year)", "N/A"
  ],
  important_goal: [
    "find a new job.", "grow my network.",  "start a new business.", "expand my business.", "advance to leadership.", "transition from my current industry to a new industry.", "enhance my transferable skills.", "enhance my sector-specific skills."
  ], 
  business_location: [
    "Rent", "Own"
  ],
  revenue: [
    "<$50,000", "$51,000-$100,000", "$101,000-$150,000", "$151,000-$500,000", "$501,000+", "N/A"
  ],
  items_type: [
    'Services', "Products", "Both", "Other"
  ],
  three_goals:  [
    "make a change to a new industry and/or role",
    "learn about job opportunities and understand my focus industry better",
    "take the next step into leadership and/or management in my field",
    "broaden and deepen my strategic network of mentors, sponsors, and/or peers",
    "build and strengthen my professional identity and become a thought leader",
    "improve my job search skills such as resume building, application techniques, and interview strategies",
    "be able to advocate for myself, confidently navigate salary negotiations, and engage in career growth discussions",
    "know how to navigate workplace challenges while promoting inclusion and belonging",
    "be empowered financially and build generational wealth"
  ]
}


export type CategoryKey = 
  | "Market Analysis and Strategy"
  | "Business Model Innovation"
  | "Scaling and Growth"
  | "Financial Management"
  | "Fundraising and Investor Relations"
  | "M&A and Partnerships"
  | "Pricing and Revenue Optimization"
  | "Customer Acquisition and Retention"
  | "Sales and Marketing Strategy"
  | "Operations Management"
  | "Leadership Development"
  | "Negotiation and Influence"
  | "Public Speaking and Media Relations"
  | "Time Management and Productivity"
  | "Personal Branding"
  | "Resilience and Overcoming Challenges"
  | "Work-Life Balance"
  | "Stress Management and Well-being"
  | "Self-Confidence and Imposter Syndrome"
  | "Mentorship and Sponsorship"
  | "Technology and Innovation"
  | "E-commerce and Digital Marketing"
  | "Social Impact and Sustainability"
  | "Healthcare and Biotech"
  | "Financial Services"
  | "Consumer Goods and Retail"
  | "Education and Technology"
  | "Energy and Cleantech"
  | "Food and Agriculture"
  | "Fashion and Apparel"
  | "Legal and Regulatory Framework"
  | "Intellectual Property Protection"
  | "Contract Negotiation"
  | "Risk Management"
  | "DE&I Strategy"
  | "Unconscious Bias"
  | "Diversity in Leadership"
  | "Supplier Diversity"
  | "Peer Support and Networking"
  | "Coaching and Consulting"
  | "Career and Life Transition"
  | "Public Relations"
  | "Other";


export type IndustryKey =
  | "Aerospace and Defense"
  | "Automotive"
  | "Banking and Capital Markets"
  | "Chemicals"
  | "Consumer Markets"
  | "Education"
  | "Energy"
  | "Engineering and Construction"
  | "Entertainment and Media"
  | "Financial Services"
  | "Healthcare"
  | "Hospitality and Leisure"
  | "Industrial Manufacturing"
  | "Insurance"
  | "Life Sciences"
  | "Mining and Metals"
  | "Oil and Gas"
  | "Power and Utilities"
  | "Real Estate"
  | "Retail"
  | "Technology"
  | "Telecommunications"
  | "Transportation and Logistics"
  | "Travel and Tourism"
  | "Other";

export type IndustryNycKey =
  | "Arts & Culture"
  | "Academia (higher ed, postgraduate, academic research)"
  | "Banking or Financial Services (banking, insurance, investment, accounting)"
  | "Business Development (commercial non-retail)"
  | "Construction"
  | "Education Services"
  | "Entertainment & Media Services"
  | "Engineering/Technical Design Services"
  | "Executive & Administrative Services"
  | "Food and Beverage Services"
  | "Government"
  | "Legal Professions"
  | "Life Sciences/Healthcare"
  | "Management of Companies/Enterprises"
  | "Manufacturing or Retail Trade"
  | "Marketing & Advertising"
  | "Personal Services (beauty/cleaning/repairs)"
  | "Professional Services/Consulting"
  | "Real Estate & Rental Licensing"
  | "Social Impact"
  | "Sustainability/Green Economy"
  | "Technology or Tech-Enabled"
  | "Transport/Warehousing/Aviation";

export type ThreeGoalsKey = 
  | "make a change to a new industry and/or role"
  | "learn about job opportunities and understand my focus industry better"
  | "take the next step into leadership and/or management in my field"
  | "broaden and deepen my strategic network of mentors, sponsors, and/or peers"
  | "build and strengthen my professional identity and become a thought leader"
  | "improve my job search skills such as resume building, application techniques, and interview strategies"
  | "be able to advocate for myself, confidently navigate salary negotiations, and engage in career growth discussions"
  | "know how to navigate workplace challenges while promoting inclusion and belonging"
  | "be empowered financially and build generational wealth";

export type AdvisorCategoryKey =
  | "Career Transition"
  | "Industry Insight"
  | "Leadership Growth"
  | "Strategic Networking"
  | "Personal Branding"
  | "Job Search Skills"
  | "Negotiation & Advocacy"
  | "Entrepreneurship & Wealth"
  | "Workplace Inclusion";

export type CurrentIndustryKey = "Tech" | "Life Sciences" | "Green Economy";

export type TranslationDict<T extends string> = Record<T, string>;


export type Translations = {
  categories: {
    en: TranslationDict<CategoryKey>;
    es: TranslationDict<CategoryKey>;
  };
  industries: {
    en: TranslationDict<IndustryKey>;
    es: TranslationDict<IndustryKey>;
  };
  industries_nyc: {
    en: TranslationDict<IndustryNycKey>;
    es: TranslationDict<IndustryNycKey>;
  };
  borough: {
    en: TranslationDict<keyof typeof BOROUGH_LIST.en>;
    es: TranslationDict<keyof typeof BOROUGH_LIST.en>;
  },
  gender:  {
    en: TranslationDict<keyof typeof GENDER_LIST.en>;
    es: TranslationDict<keyof typeof GENDER_LIST.en>;
  },
  age: {
    en: TranslationDict<keyof typeof AGE_LIST.en>;
    es: TranslationDict<keyof typeof AGE_LIST.en>;
  },
  race:{
    en: TranslationDict<keyof typeof RACE_LIST.en>;
    es: TranslationDict<keyof typeof RACE_LIST.en>;
  },
  ethnicity: {
    en: TranslationDict<keyof typeof ETHNICITY_LIST.en>;
    es: TranslationDict<keyof typeof ETHNICITY_LIST.en>;
  },
  education: {
    en: TranslationDict<keyof typeof EDUCATION_LIST.en>;
    es: TranslationDict<keyof typeof EDUCATION_LIST.en>;
  },
  incomeRange: {
    en: TranslationDict<keyof typeof INCOME_RANGE_LIST.en>;
    es: TranslationDict<keyof typeof INCOME_RANGE_LIST.en>;
  },
  occupationStatus: {
    en: TranslationDict<keyof typeof OCCUPATION_STATUS_LIST.en>;
    es: TranslationDict<keyof typeof OCCUPATION_STATUS_LIST.en>;
  },
  professionalExperience: {
    en: TranslationDict<keyof typeof PROFESSIONAL_EXPERIENCE_LIST.en>;
    es: TranslationDict<keyof typeof PROFESSIONAL_EXPERIENCE_LIST.en>;
  },
  highGrowthIndustry: {
    en: TranslationDict<keyof typeof HIGH_GROWTH_INDUSTRY_LIST.en>;
    es: TranslationDict<keyof typeof HIGH_GROWTH_INDUSTRY_LIST.en>;
  },
  areaInterest: {
    en: TranslationDict<keyof typeof AREA_OF_INTERESTS_LIST.en>;
    es: TranslationDict<keyof typeof AREA_OF_INTERESTS_LIST.en>;
  },
  howYouFoundUs: {
    en: TranslationDict<keyof typeof HOW_DID_YOU_HEAR_ABOUT_US_LIST.en>;
    es: TranslationDict<keyof typeof HOW_DID_YOU_HEAR_ABOUT_US_LIST.en>;
  },
  business_start_period: {
    en: TranslationDict<keyof typeof BUSINESS_START_PERIOD.en>;
    es: TranslationDict<keyof typeof BUSINESS_START_PERIOD.en>;
  };
  mwbe: {
    en: TranslationDict<keyof typeof MWBE.en>;
    es: TranslationDict<keyof typeof MWBE.en>;
  };
  employees_count: {
    en: TranslationDict<keyof typeof EMPLOYEES_COUNT.en>;
    es: TranslationDict<keyof typeof EMPLOYEES_COUNT.en>;
  };
  business_stage: {
    en: TranslationDict<keyof typeof BUSINESS_STAGE.en>;
    es: TranslationDict<keyof typeof BUSINESS_STAGE.en>;
  };
  important_goal: {
    en: TranslationDict<keyof typeof IMPORTANT_GOAL.en>;
    es: TranslationDict<keyof typeof IMPORTANT_GOAL.en>;
  };
  business_location: {
    en: TranslationDict<keyof typeof BUSINESS_LOCATION.en>;
    es: TranslationDict<keyof typeof BUSINESS_LOCATION.en>;
  };
  revenue: {
    en: TranslationDict<keyof typeof REVENUE.en>;
    es: TranslationDict<keyof typeof REVENUE.en>;
  };
  items_type: {
    en: TranslationDict<keyof typeof ITEMS_TYPE.en>;
    es: TranslationDict<keyof typeof ITEMS_TYPE.en>;
  };
  three_goals: {
    en: TranslationDict<keyof typeof THREE_GOALS.en>;
    es: TranslationDict<keyof typeof THREE_GOALS.en>;
  };
  advisorCategories: {
    en: TranslationDict<keyof typeof ADVISOR_CATEGORIES.en>;
    es: TranslationDict<keyof typeof ADVISOR_CATEGORIES.en>;
  };
  currentIndustry: {
    en: TranslationDict<keyof typeof CURRENT_INDUSTRY_LIST.en>;
    es: TranslationDict<keyof typeof CURRENT_INDUSTRY_LIST.en>;
  }
};

export const TRANSLATIONS: Translations = {
  categories: CATEGORIES,
  industries: INDUSTRIES, 
  industries_nyc: INDUSTRIES_NYC,
  borough: BOROUGH_LIST,
  gender:  GENDER_LIST,
  age: AGE_LIST,
  race: RACE_LIST,
  ethnicity: ETHNICITY_LIST,
  education: EDUCATION_LIST,
  incomeRange: INCOME_RANGE_LIST,
  occupationStatus: OCCUPATION_STATUS_LIST,
  professionalExperience: PROFESSIONAL_EXPERIENCE_LIST,
  highGrowthIndustry: HIGH_GROWTH_INDUSTRY_LIST,
  areaInterest: AREA_OF_INTERESTS_LIST,
  howYouFoundUs: HOW_DID_YOU_HEAR_ABOUT_US_LIST,
  business_start_period: BUSINESS_START_PERIOD,
  mwbe: MWBE,
  employees_count: EMPLOYEES_COUNT,
  business_stage: BUSINESS_STAGE,
  important_goal: IMPORTANT_GOAL, 
  business_location: BUSINESS_LOCATION,
  revenue: REVENUE,
  items_type: ITEMS_TYPE,
  three_goals: THREE_GOALS,
  advisorCategories: ADVISOR_CATEGORIES,
  currentIndustry: CURRENT_INDUSTRY_LIST
};
